import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';

// Import pages
import Home from './pages/Home';
import MCPZero from './pages/MCPZero';
import MetaNode from './pages/MetaNode';
import ZKPhysics from './pages/ZKPhysics';
import Contact from './pages/Contact';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Global styles
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: 'Roboto', sans-serif;
    line-height: 1.6;
    background-color: #f8f9fa;
    color: #333;
  }
  
  a {
    text-decoration: none;
    color: #0066cc;
  }
  
  ul {
    list-style: none;
  }
  
  img {
    max-width: 100%;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .btn {
    display: inline-block;
    background: #0066cc;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: #004c99;
    }
  }
`;

function App() {
  return (
    <Router>
      <GlobalStyle />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mcp-zero" element={<MCPZero />} />
        <Route path="/metanode" element={<MetaNode />} />
        <Route path="/zk-physics" element={<ZKPhysics />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
